import { onMounted, onBeforeUnmount } from "vue";

export function useFocusVisible() {
  const handleFirstTab = (e: KeyboardEvent) => {
    if (e.key === "Tab") {
      document.body.classList.add("user-is-tabbing");
      window.removeEventListener("keydown", handleFirstTab);
      window.addEventListener("mousedown", handleMouseDownOnce);
    }
  };

  const handleMouseDownOnce = () => {
    document.body.classList.remove("user-is-tabbing");
    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
  };

  onMounted(() => {
    window.addEventListener("keydown", handleFirstTab);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("keydown", handleFirstTab);
    window.removeEventListener("mousedown", handleMouseDownOnce);
  });
}
